import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { FiltersProvider } from './FiltersProvider';
import { FilterBoxChips } from './FilterBoxChips';
import styles from './filter_box.module.scss';
import { Paper } from '../../../../../components/paper/Paper';
import { FilterType } from './FilterItem';

type Props = {
  searchType: 'arret' | 'commentary' | 'law';
};

export const FilterBox: FC<Props> = ({ searchType }) => {
  return (
    <Paper level={0} className={styles.container}>
      <div className={styles.header}>
        <FormattedMessage id="search/components/search-snippets/aside/filter-box/FilterBox.tsx/4" />
      </div>
      <FiltersProvider>
        {(filters: Array<FilterType>) => (
          <FilterBoxChips searchType={searchType} filters={filters} />
        )}
      </FiltersProvider>
    </Paper>
  );
};
